import { ProductType } from '@sparelabs/api-client'
import { EngageProductType } from '../types'

export enum EngageFeature {
  ActivityFeed = 'activityFeed',
  ActivityLog = 'activityLog',
  Appointments = 'appointments',
  Forms = 'forms',
  Groups = 'groups',
  Letters = 'letters',
  Timer = 'timer',
  ObjectLinks = 'objectLinks',
}

export const EngageProductFeatureMap: Record<EngageProductType, EngageFeature[]> = {
  [ProductType.Eligibility]: [
    EngageFeature.ActivityFeed,
    EngageFeature.ActivityLog,
    EngageFeature.Appointments,
    EngageFeature.Forms,
    EngageFeature.Groups,
    EngageFeature.Letters,
    EngageFeature.Timer,
  ],
  [ProductType.Resolve]: [
    EngageFeature.ActivityFeed,
    EngageFeature.ActivityLog,
    EngageFeature.Forms,
    EngageFeature.Letters,
    EngageFeature.ObjectLinks,
  ],
}
